<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="`${id}-header`">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#${id}`" aria-expanded="false" :aria-controls="`#${id}`" @click="open">
        <img v-if="iconDomain" :src="`http://www.google.com/s2/favicons?domain=${iconDomain}`" height="16" width="16" class="me-2" />
        <span v-if="iconName" class="bi me-2 text-info text-secondary" :class="iconName"></span>
        {{ label }}
      </button>
    </h2>
    <div :id="id" class="accordion-collapse collapse">
      <div class="accordion-body mb-5" style="min-height: 50vh;">
        <transition name="fade" mode="out-in">
         <slot v-if="show"></slot>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, nextTick } from "vue"
defineProps(["label", "id", "iconDomain", "iconName"]);
const show = ref(false)
async function open(e) {
  show.value=true
  await nextTick()
  e.target?.blur()
}
</script>

<style lang="scss" scoped>

</style>
